import { UploadFile } from '@mui/icons-material';
import { Grid, Alert, lighten, AlertTitle, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Colors } from 'src/shared/components/styles/colors';

export const MemberImportPendingMessage = () => {
  const { t } = useTranslation(['member']);

  return (
    <Grid item xs={12}>
      <Alert
        severity='info'
        icon={<UploadFile />}
        variant='outlined'
        sx={{ backgroundColor: lighten(Colors.ChipColors.Blue, 0.9), '& .MuiAlert-message': { width: '100%' } }}
      >
        <Box>
          <AlertTitle>{t('member:memberDetails.importPendingHeader')}</AlertTitle>
          <Typography>{t('member:memberDetails.importPendingDescription')}</Typography>
        </Box>
      </Alert>
    </Grid>
  );
};
